module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('client-blank-form', {
    attrs: {
      "submit-label": "Добавить клиента",
      "client": _vm.client,
      "errors": _vm.errors,
      "form-type": "add"
    },
    on: {
      "submit": _vm.processClientForm
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5332d3d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/client/ClientAddForm.vue
// module id = 645
// module chunks = 0